import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './services/interceptor.service';
import { HttpService } from './services/http.service';
import { SharedModule } from './shared/shared.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MatNativeDateModule } from '@angular/material/core';
import { NgOtpInputModule } from 'ng-otp-input';
import { CreditCardDirectivesModule } from 'angular-cc-library';

import { AuthGuard } from './services/auth.guard';
import { LoginGuard } from './services/login.guard';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { DatePipe } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CdkColumnDef } from '@angular/cdk/table';
import { AuthDialogModule } from './components/global-dialog/auth-dialog/auth-dialog.module';
import { ApiVersionInterceptor } from './services/corporate/api-version.interceptor';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CarouselModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    NgOtpInputModule,
    HttpClientModule,
    NgxSliderModule,
    NgxStarRatingModule,
    CreditCardDirectivesModule,
    MatSidenavModule,
    // AuthDialogModule
  ],
  providers: [
    HttpService,
    CdkColumnDef,
    AuthGuard,
    LoginGuard,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ApiVersionInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
